import {
  POPULATE_INSIGHTS,
  SELECT_INSIGHTS_VIEW,
  TOGGLE_INSIGHTS,
} from 'constants/actions';

export const toggleViewerInsightsUI = () => {
  return { type: TOGGLE_INSIGHTS };
};

export const populateViewerInsightsViewers = viewers => {
  return { type: POPULATE_INSIGHTS, viewers };
};

export const selectInsightsView = selectedView => {
  return { type: SELECT_INSIGHTS_VIEW, selectedView };
};
